// src/components/IncomingCallModal.tsx
import React from 'react';
import { useTwilio } from '../twilio/twilio_provider';
import { Box, Button, Modal, Typography } from '@mui/material';

export const IncomingCallModal: React.FC = () => {
    const {
        incomingCall,
        activeCall,
        callStatus,
        callDuration,
        accept,
        reject,
        hangup,
        user
    } = useTwilio();

    return (
        <Modal open={Boolean(incomingCall) || Boolean(activeCall)} disableAutoFocus disableRestoreFocus>
            <>
                {incomingCall
                    ? (
                        <Box
                            position="absolute" top="30%" left="50%"
                            display="flex" flexDirection="column" justifyContent="space-between" alignItems="center"
                            sx={{
                                transform: 'translate(-50%, -30%)',
                                bgcolor: 'background.paper',
                                p: 4,
                                borderRadius: 2,
                                boxShadow: 24,
                                minWidth: 300,
                                minHeight: 300
                            }}>
                            <Box>
                                <Typography variant="h3" fontWeight={'bold'} textAlign={'center'} gutterBottom>
                                    {user ? user.contact_name : 'unknown'}
                                </Typography>
                                <Typography variant="subtitle1" color="text.secondary" textAlign={'center'} gutterBottom>
                                    {user ? user.deal_name : 'unknown'}
                                </Typography>
                                <Typography variant="body1" textAlign={'center'} gutterBottom>
                                    {incomingCall.parameters.From}
                                </Typography>
                            </Box>
                            <Box width="100%" display="flex" gap={2} justifyContent="center" mt={2}>
                                <Button fullWidth variant="contained" color="primary" onClick={accept}>
                                    Answer
                                </Button>
                                <Button fullWidth variant="contained" color="error" onClick={reject}>
                                    Reject
                                </Button>
                            </Box>
                        </Box>
                    )
                    : activeCall
                        ? (
                            <Box
                                position="absolute" top="30%" left="50%"
                                display="flex" flexDirection="column" justifyContent="space-between" alignItems="center"
                                sx={{
                                    transform: 'translate(-50%, -30%)',
                                    bgcolor: 'background.paper',
                                    p: 4,
                                    borderRadius: 2,
                                    boxShadow: 24,
                                    minWidth: 300,
                                    minHeight: 300
                                }}>
                                <Typography variant="h3" fontWeight={'bold'} textAlign={'center'} gutterBottom>
                                    {user ? user.contact_name : 'unknown'}
                                </Typography>
                                <Typography variant="subtitle1" color="text.secondary" textAlign={'center'} gutterBottom>
                                    {user ? user.deal_name : 'unknown'}
                                </Typography>
                                <Typography variant="body1" textAlign={'center'} gutterBottom>
                                    {callStatus}: {activeCall.parameters.From}
                                </Typography>
                                <Typography textAlign={'center'} variant="body2" sx={{ mb: 4 }}>
                                    Duration: {Math.floor(callDuration / 60)}:{(callDuration % 60).toString().padStart(2, '0')}
                                </Typography>
                                <Button
                                    variant="contained"
                                    color="error"
                                    fullWidth
                                    onClick={hangup}
                                >
                                    Hang Up
                                </Button>
                            </Box>
                        )
                        : null}
            </>
        </Modal>
    );
};
